var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleIdle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 332,
    fill: "none",
    viewBox: "0 0 150 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10511",
    width: 119,
    height: 376,
    x: 11,
    y: -92,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M129.061 281.447L17.8031 283.389L11.2897 -89.764L122.548 -91.706L129.061 281.447Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M96.8649 -82.8219C104.102 -74.8574 128.807 -28.741 122.807 -19.174C63.3532 75.6157 77.1619 249.504 77.6121 251.006C77.6121 251.006 74.0793 277.778 61.0026 281.678C47.9229 285.581 31.8867 278.661 27.9585 265.632C25.852 258.636 -13.8688 34.5089 57.5467 -79.348C64.7878 -90.8908 80.0484 -94.4 91.6306 -87.1817C93.6152 -85.9456 95.3656 -84.4719 96.8649 -82.8219Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M78.0669 -86.5303C80.0522 -85.2924 81.8026 -83.8181 83.3004 -82.1698C90.5387 -74.2042 115.245 -28.0866 109.244 -18.5205C49.7887 76.2671 63.5996 250.158 64.0497 251.659C67.8648 264.418 60.8129 277.821 48.2536 282.045C52.3285 283.003 56.6998 282.962 61.0024 281.678C74.0791 277.778 77.6119 251.006 77.6119 251.006C77.1617 249.503 63.353 75.6156 122.807 -19.1741C128.807 -28.7411 104.102 -74.8575 96.8647 -82.822C95.3654 -84.4719 93.615 -85.9457 91.6304 -87.1818C85.0791 -91.2631 77.3541 -91.9104 70.5675 -89.6176C73.1536 -89.0171 75.6899 -88.0111 78.0669 -86.5303Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M126.052 266.672C129.578 270.553 130.35 276.411 127.556 281.17L115.366 301.934C112.91 306.119 108.222 308.479 103.386 307.97L64.5713 303.865C57.7826 303.146 52.8606 297.075 53.5802 290.31C54.3 283.541 60.3914 278.633 67.1834 279.352L98.0536 282.615L106.207 268.722C109.656 262.846 117.232 260.871 123.126 264.306C124.246 264.959 125.225 265.763 126.052 266.672Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M80.7229 232.408C55.5276 220.893 20.9073 212.353 23.3576 238.185C27.3552 280.329 44.2895 319.046 70.5295 320.184C70.5295 320.184 86.9282 306.515 90.7373 290.285C66.5161 254.897 80.7229 232.408 80.7229 232.408Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M70.3451 256.027C70.7022 265.575 78.6837 285.21 90.7373 290.285C66.516 254.897 82.9085 227.58 82.9085 227.58C76.5319 224.665 69.6804 238.082 70.3451 256.027Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_10511",
    width: 95,
    height: 71,
    x: 55,
    y: 260,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M149.658 328.429L57.1031 330.045L55.9185 262.18L148.473 260.565L149.658 328.429Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_10511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M145.487 264.828C147.672 267.232 148.905 270.484 148.659 273.974C148.347 278.365 144.806 317.143 116.933 326.635C90.7941 335.534 63.7366 319.192 62.5978 318.491C56.7841 314.916 54.9765 307.324 58.5646 301.529C62.1427 295.746 69.7394 293.94 75.5475 297.486C80.6225 300.545 96.4952 307.544 108.942 303.307C118.783 299.955 123.395 280.565 123.985 272.236C124.467 265.445 130.383 260.329 137.193 260.811C140.507 261.042 143.423 262.556 145.487 264.828Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_10511",
    width: 54,
    height: 70,
    x: 96,
    y: 260,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M149.658 328.425L97.2884 329.339L96.104 261.481L148.473 260.567L149.658 328.425Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_10511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M137.522 264.964C139.707 267.368 140.942 270.62 140.692 274.112C140.381 278.501 136.842 317.279 108.967 326.771C105.064 328.102 101.141 328.857 97.2859 329.196C103.603 329.522 110.295 328.895 116.932 326.635C144.806 317.142 148.346 278.365 148.659 273.974C148.905 270.484 147.672 267.232 145.487 264.827C143.422 262.556 140.507 261.042 137.193 260.81C135.406 260.684 133.692 260.962 132.111 261.535C134.219 262.204 136.085 263.383 137.522 264.964Z",
    clipRule: "evenodd"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M67.5821 297.622C72.0873 300.338 85.1035 306.142 96.6776 304.446C87.6131 303.545 79.0329 299.586 75.5471 297.486C72.2193 295.457 68.3099 295.189 64.9016 296.408C65.8191 296.704 66.7211 297.097 67.5821 297.622Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M64.4974 311.566C74.1487 314.884 106.881 323.988 122.968 317.452C131.698 313.658 138.456 307.175 143.006 298.704C147.517 287.157 148.502 276.188 148.659 273.974C148.905 270.484 147.672 267.232 145.487 264.827C143.423 262.556 140.507 261.042 137.193 260.81C131.817 260.43 127.047 263.564 125.018 268.226C125.146 276.246 123.646 282.868 120.665 287.623C118.218 294.7 114.381 301.455 108.942 303.307C96.4949 307.544 80.6222 300.545 75.5475 297.486C69.7394 293.94 62.1427 295.746 58.5646 301.529C57.7307 302.879 57.1981 304.326 56.9298 305.798C58.6338 308.507 61.2578 310.643 64.4974 311.566Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M143.129 245.57C144.805 247.414 145.939 249.777 146.244 252.437C149.426 280.211 139.568 301.925 119.875 310.522C103.908 317.494 72.8498 311.523 63.7106 309.528C57.0366 308.071 52.8144 301.497 54.2768 294.85C55.7414 288.2 62.3339 283.99 69.0045 285.446C84.0515 288.717 104.093 290.501 109.955 287.942C119.313 283.857 123.583 271.937 121.671 255.237C120.896 248.476 125.769 242.365 132.553 241.593C136.671 241.124 140.545 242.726 143.129 245.57Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M132.254 223.945C135.608 227.636 136.506 233.153 134.091 237.846C130.98 243.895 123.544 246.288 117.473 243.206C112.685 240.795 97.8626 234.996 86.8843 237.134C76.1647 239.221 70.2125 252.622 70.1559 252.758C67.5659 259.055 60.3414 262.071 54.0218 259.488C47.7079 256.901 44.6817 249.707 47.2695 243.408C47.7019 242.357 58.1338 217.615 82.1468 212.94C103.477 208.785 126.207 219.967 128.73 221.255C130.097 221.953 131.279 222.872 132.254 223.945Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M135.343 231.455C135.343 231.455 135.608 227.636 132.254 223.945C131.279 222.872 130.098 221.953 128.73 221.255C126.207 219.967 103.476 208.785 82.1468 212.94C78.7782 213.594 75.6885 214.656 72.8435 215.98C93.8284 212.445 128.984 221.164 135.343 231.455Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M120.702 217.766C115.661 219.041 114.074 226.01 116.581 229.505C117.325 230.542 118.349 231.347 119.534 231.826L130.323 236.24L134.091 237.845L134.477 236.958C137.15 230.803 134.329 223.653 128.167 220.962L121.971 218.257L120.702 217.766Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4EAA",
    fillRule: "evenodd",
    d: "M133.636 241.458L133.121 251.977C133.046 253.288 133.346 254.592 133.987 255.739C137.76 261.465 143.377 260.587 146.693 257.644C147.297 244.649 139.563 241.67 133.636 241.458Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.8,
    d: "M75.8076 204.515C104.573 188.02 -5.73399 204.025 6.96184 221.501C8.84956 224.1 17.7912 223.652 20.9746 222.768"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.8,
    d: "M19.3949 204.361C-14.9045 205.674 87.8579 159.809 86.8645 181.796C86.7166 185.064 78.7286 189.518 75.4711 190.478"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIdle);
export default __webpack_public_path__ + "static/media/female_idle.599b469977f7ce0b8e7295d10b6aea37.svg";
export { ForwardRef as ReactComponent };